import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public currentPage = new BehaviorSubject<string>(null);
  public userFullName = new BehaviorSubject<string>(null);

  constructor() {
  }
}
